module.exports = __webpack_public_path__ + "static/media/friends-logo.0b6e3582.svg";